<style scoped>
    .hasResults {
        display: inline;
    }

    .noResults {
        display: none;
    }
    .class-wrapper {
        width: 100%;
    }

    .showTick{
        display: inline;
        color:green;
    }
    .hideTick{
        display: none;
    }

    .ungraded  {
        color: #ec4949;
    }
</style>
<template>
    <div style="width:100%" class="effort-grades">
        <v-toolbar-title  v-if="hideTitle != 'true'">
            {{ this.className(value) }}
        </v-toolbar-title>
        <v-tabs
            color="primary"
            dark
            slider-color="primary"
            :value="active"
        >
            <v-tab :ripple="true" v-for="effort in value.effortGroups"  
            :key="effort.groupId" @click.stop="updateActive(effort.groupName, effort.groupId)">
                {{ effort.groupName }}
                <v-icon v-bind:class="{'showTick': effort.isComplete, 'hideTick': !effort.isComplete }">
                    check_circle_outline
                </v-icon>
            </v-tab>

            <v-tab-item v-for="effort in value.effortGroups" 
            :key="effort.groupId" v-bind:id="'top_' + effort.groupId" class="grading-tabs-scroll-area">
                <v-layout row wrap >
                </v-layout>
                <v-container class="effort-description">
                    <v-layout row v-bind:id="'group_' + effort.groupId.toString()">
                        <v-flex>
                            <h2>{{ effort.groupName  }}</h2>

                            <div>
                                {{ effort.groupDescription }}
                            </div>
                        </v-flex>
                    </v-layout>
                </v-container>
                <div class="grades-pane">
                    <v-card  v-for="classEffort in effort.effortGroups" :key="classEffort.reportingPeriodClassId"
                        v-bind:id="effort.groupName.toLowerCase() + '_card_' + classEffort.efforts[0].studentId"
                        >
                        <v-divider></v-divider>
                        <v-card-title >
                            <h3 v-bind:class="{'ungraded': isStudent && classEffort.efforts[0].grade == 0}">
                                {{ classEffort.groupName }}
                            </h3>
                        </v-card-title>
                        <v-card-text v-for="eff in classEffort.efforts" class="py-2" :key="eff.teacherEffortId" >
                            <grading-buttons v-model="classEffort.efforts" v-on:grade-changed="onGradeChanged" ref="buttons"
                            v-on:save-failed="saveFailed" :settings="effort.settings" 
                            :readonly="readonly" :active="active" :classId="classId" />
                        </v-card-text>
                    </v-card>
                </div>
              
            </v-tab-item>

        </v-tabs>

        <v-container :class="{ 'pa-0':1,  'hasResults': typeof(this.value.groupName) != 'undefined', 'noResults': typeof(this.value.groupName) == 'undefined'}">
            <v-layout row wrap class="efforts-nav">
                <v-btn @click.native="prev" v-bind:disabled="prevDisabled">prev</v-btn>

                <v-spacer></v-spacer>

                <v-btn  @click.native="finish">finish</v-btn>
                <v-btn @click.native="next" v-bind:disabled="nextDisabled">next</v-btn>
            </v-layout>


        </v-container>
        <v-dialog v-model="dialog" max-width="35%">
            <v-card>
                <v-card-title>
                    Information
                </v-card-title>
                <v-card-text>
                    <v-layout row wrap>
                        {{ this.message }}
                    </v-layout>
                </v-card-text>
                <v-card-text v-for="name in incompletes" :key="name">
                    <v-layout row wrap>
                        {{ name }}
                    </v-layout>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" flat @click.stop="cleanDialog()">Continue Grading</v-btn>
                    <v-btn color="primary" v-if="!isStudent" flat @click.stop="saveAndExit()">Save and Exit</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>


</template>


<script>
    import GradingButtons from './GradingButtons'
    import { getSettings, getStudentEfforts, getTeacherEfforts } from '../utils/effort-tracking-api';

    export default {
        name: 'grading-tabs',
        props: [ 'value', 'classId', 'hideTitle', 'isStudent', 'settings', 'readonly' ],
        data() {
            return {
                active: "0",
                error: false,
                prevDisabled : false,
                nextDisabled: false,
                dialog: false,
                message: 'You still have unassigned grades. Please complete them before finishing your grading',
                incompletes: [],
                studentCard: true,
                activeSettings: [],
                selectedEffort: 0
            }
        },
        components: {
            GradingButtons
        },
        watch: {
            active: {
                handler(value)  {
                    this.prevDisabled = (value == 0 ? true : false);
                    this.nextDisabled = (value == 2 ? true : false);
                    var id = 'top_' + this.selectedEffort;
                     setTimeout(() => {
                        var element = document.getElementById(id);
                        if(element != null)
                            element.scrollTo(0, 0);
                    }, 100);
                }
            },
            classId: {
                handler(value) {
                    this.active = 0;
                    var id = 'top_' + this.selectedEffort;
                    const active = parseInt(this.active)
                    this.active = (active > 0 ? active - 1 : 0);

                    setTimeout(() => {
                        var element = document.getElementById(id);
                        if(element != null)
                            element.scrollTo(0, 0);
                    }, 100);
                }
            }
        },
        methods: {
            onGradeChanged: function(data, classId) {
                this.$emit('grade-changed', data, classId);
            },
            saveFailed() {
                this.$emit('save-failed');
            },
            next() {
                this.updateSelectedEffort('n');
                var id = 'top_' + this.selectedEffort;
                const active = parseInt(this.active)
                this.active = (active < 2 ? active + 1 : 2);
                setTimeout(() => {
                    var element = document.getElementById(id);
                    element.scrollTo(0, 0);
                }, 100);
            },
            prev() {
                this.updateSelectedEffort('p');
                var id = 'top_' + this.selectedEffort;
                const active = parseInt(this.active)
                this.active = (active > 0 ? active - 1 : 0);

                setTimeout(() => {
                    var element = document.getElementById(id);
                    element.scrollTo(0, 0);
                }, 100);
            },
            finish() {
                if (this.$route.params.studentId !== undefined)
                {
                    getStudentEfforts(this.$route.params.studentId, this.$route.params.periodId).then((effortsRefresh) => {
                        if(effortsRefresh.isComplete)
                        {
                            window.location.href = '#/thankyou';
                        } else {
                            this.dialog = true;
                        }
                    });
                }

                if (this.$route.params.teacherId !== undefined)
                {
                    getTeacherEfforts(this.$route.params.teacherId, this.classId).then((efforts) => {
                        if(efforts.isComplete)
                        {
                            window.location.href = '#/thankyou';
                        } else {
                            this.dialog = true;
                        }
                    });
                        

                }
            },
            cleanDialog() {
                this.dialog = false;
                this.incompletes = [];
            },
            saveAndExit() {
                this.cleanDialog();
                window.location.href = '#/';
            },
            className(classInfo) {
                var className = "";
                if(typeof(classInfo.groupName) != 'undefined' && classInfo.groupName != '')
                    className = classInfo.groupName + " - Effort Tracking";

                return  className;
            },
            updateActive(effortName, effortId) {
                var tabsEnum = {
                    DILIGENCE: 0,
                    ENGAGEMENT: 1,
                    BEHAVIOUR: 2
                };

                Object.getOwnPropertyNames(tabsEnum).forEach( (i, v) => {
                    if ( i == effortName) {
                        this.active = v;
                    }
                });

                this.selectedEffort = effortId;
                
            },
            updateSelectedEffort(direction) {
                var tabsEnum = {
                    DILIGENCE: 0,
                    ENGAGEMENT: 1,
                    BEHAVIOUR: 2
                };


                var efforts = this.value;
                Object.getOwnPropertyNames(tabsEnum).forEach( (v, i) => {
                    if(this.active == i)
                    {
                        if(direction == 'n')
                        {
                            var effort = efforts.effortGroups[i + 1];
                            this.selectedEffort = effort.groupId;
                        } else {
                            var effort = efforts.effortGroups[i - 1];
                            this.selectedEffort = effort.groupId;
                        }
                    }
                });
            },
            reset() {
                this.value.effortGroups = [];
                this.value.groupId = 0;
                this.value.groupName = '';
                this.className(this.value);
                var element = document.getElementsByClassName("effort-grades")
                element[0].style.display = 'none';
            }
        },
        mounted() {
            var element = document.getElementsByClassName("effort-grades")
            element[0].style.display = 'inline';

            if(this.value.length > 0)
                this.selectedEffort = this.value.effortGroups[0].groupId;

            this.prevDisabled = (this.active == 0 ? true : false);
            this.nextDisabled = (this.active == 2 ? true : false);
            this.active = 0;
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/GradingTabs.vue